var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader",style:(_vm.style),on:{"transitionend":_vm.onTransitionEnd}},[_c('img',{attrs:{"src":_vm.preloaderImage}}),(_vm.percents)?_c('div',{staticClass:"percents"},[_vm._v(_vm._s(_vm.displayPercents))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }